export default __webpack_public_path__ + "static/media/DisAlignMiddle.3ddbea09.svg";